// extracted by mini-css-extract-plugin
module.exports = {"reporting-tools-image":"styles_reporting-tools-image__dDDNu"};